var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.$props.visible)?_c('div',{ref:"backdrop",staticClass:"base-drawer",on:{"click":_vm.handleBackdropClick}},[_c('div',{staticClass:"drawer-content",class:_vm.contentClasses},[_vm._t("default")],2)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }